module.exports = __webpack_public_path__ + "img/1.c8a90840.png";